import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { WalletProvider } from "@/contexts/WalletContext";
import { AuthProvider } from "@/contexts/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ErrorBoundary from "@/components/ErrorBoundary";
import Home from "@/pages/Home";
import Create from "@/pages/Create";
import Explore from "@/pages/Explore";
import Verified from "@/pages/Verified";
import Watchlist from "@/pages/Watchlist";
import NotFound from "@/pages/NotFound";
import CoinDetail from "@/pages/CoinDetail";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Pricing from "@/pages/Pricing";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Admin from "@/pages/Admin";
import MyCoins from "@/pages/MyCoins";
import Login from "@/pages/Login";
import Leaderboard from "@/pages/Leaderboard";
import LaunchAssistant from "@/components/LaunchAssistant";
import ComfortAutoNotice from "@/components/ComfortAutoNotice";

function AppRouter() {
  const location = useLocation();
  // Capture ?ref= referral codes (last-click attribution) before anything renders.
  useEffect(() => {
    const ref = new URLSearchParams(location.search).get("ref");
    if (ref) localStorage.setItem("spur_ref", ref.slice(0, 20));
  }, [location.search]);
  // Synchronous check during render: process session_id BEFORE any route renders.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/create" element={<Create />} />
      <Route path="/explore" element={<Explore />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/c/:slug" element={<CoinDetail />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/my-coins" element={<MyCoins />} />
      <Route path="/login" element={<Login />} />
      <Route path="/leaderboard" element={<Leaderboard />} />
      <Route path="/verified" element={<Verified />} />
      <Route path="/watchlist" element={<Watchlist />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <WalletProvider>
          <BrowserRouter>
            <ErrorBoundary>
              <AppRouter />
              <LaunchAssistant />
              <ComfortAutoNotice />
            </ErrorBoundary>
          </BrowserRouter>
          <Toaster position="bottom-right" theme="dark" />
        </WalletProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
